/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
export const awsAuth = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_dvjROtJxF",
    "aws_user_pools_web_client_id": "20h267h904n327jalk2okj2sem",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};
export const awsAuthHosted = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_dvjROtJxF",
    "aws_user_pools_web_client_id": "20h267h904n327jalk2okj2sem",
    "oauth": {
        "domain": "gytpol-saas-gentoo.auth.eu-central-1.amazoncognito.com",
        "scope": ["email", "openid","profile"],     // "aws.cognito.signin.user.admin"
        "redirectSignIn": "https://gentoo.eu.cloud.gytpol.com",
        "redirectSignOut": "https://gentoo.eu.cloud.gytpol.com",
        "region": "eu-central-1",
        "responseType": "code"
    }
};
